import {
    defaults,
    withDefaultOptions,
    required,
    number,
    int,
    positive,
    negative,
    money,
    length,
    range,
    regexp,
    email,
    oneOf,
    oneOfBy,
    ascending,
    equal,
    notEqual,
    confirm,
    fn,
    func
} from '@core/js/utils/Validation/validationMethods';

export * from '@core/js/utils/Validation/validationMethods';

defaults.money.re = /^([0-9']+(\d+[.,]?\d{0,2}$)|([.,']\d{1,2}$))/;

export default withDefaultOptions({
    defaults,
    required,
    number,
    int,
    positive,
    negative,
    money,
    length,
    range,
    regexp,
    email,
    oneOf,
    oneOfBy,
    ascending,
    equal,
    notEqual,
    confirm,
    fn,
    func
});
